module.exports = __webpack_public_path__ + "static/media/distributed_cache.53c213cd.png";